<div class="d-flex align-items-center justify-content-center mt-5">
  <div class="text-center">
    <!-- Icon -->
    <div class=" d-flex justify-content-center">
      <svg viewBox="0 0 8 14" fill="#ba3d21" focusable="false" aria-hidden="true" width="80" height="80">
        <use xlink:href="#error-small"></use>
      </svg>
    </div>

    <!-- Title -->
    <ng-container *ngIf="!errorMessage; else title">
      <h1>Try again later</h1>
    </ng-container>
    <ng-template #title>
      <h1>Access Denied</h1>
    </ng-template>
    <!-- Message -->
    <p class="c11n-text-md" style="max-width: 500px;">
      <ng-container *ngIf="!errorMessage; else withError">
        We are experiencing technical difficulties. We apologize for the temporary inconvenience. You might be logged
        out; please try to log in.
      </ng-container>
      <ng-template #withError>
        {{ errorMessage }}
      </ng-template>
    </p>
  </div>
</div>
